export default "__VITE_ASSET__9f0b7596__"